// The five runtime-owned realtime SYSTEM methods — the frozen v1 webhook lifecycle seam. Do not rename:
// these are published method names the platform invokes by string.
export const REALTIME_SYSTEM_METHODS = {
  UPSERT: 'handleTriggerUpsertWebhook',
  RESOLVE: 'handleTriggerResolveEvents',
  SELECT: 'handleTriggerSelectMatched',
  DELETE: 'handleTriggerDeleteWebhook',
  REFRESH: 'handleTriggerRefreshWebhook',
} as const
